import * as React from 'react';

import GaugeChart from "react-gauge-chart";

//import GaugeComponent from "react-gauge-component";

//import { Gauge } from "@mui/x-charts/Gauge";


import {
    Box,
    Grid,
    Card,
    Typography, 
   
} from '@mui/material';
import { LanguageContext } from './LanguageContext';
import { authFetch } from "./../authProvider";

const API_KPI_PREFIX = 'api/Home/KPI';

const API_DATAEXPORT_PREFIX = 'api/export/table';

const default_columns = [
    {
        label: "Channel",
        name: "channel",
        options: {
            filter: false,
            display: false
        }
    },

    {
        label: "Account",
        name: "account",
        options: {
            filter: false,
            display: true,
        }
    },

    {
        label: "CurrentMonthImpressions",
        name: "currentMonthImpressions",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "TotalImpressions",
        name: "totalImpressions",
        options: {
            filter: false,
            display: false
        }
    },
    {
        label: "GoalImpressions",
        name: "goalImpressions",
        options: {
            filter: false,
            display: false
        }
    }
]

export class Home extends React.Component {
    static contextType = LanguageContext;

    constructor(props) {
        super(props);

        // Initialize component state
        this.state = {
            kpis: [], 
            loading: true

        }
        //this.fetchKPIData();
    }

    fetchKPIData = () => {
        authFetch(this.props.pca, API_KPI_PREFIX + '/Read')
            .then(response => response.json())
            .then(data => {

                this.setState({
                    kpis: data,
                    loading: false
                });
            });
    }

    componentDidMount() {
        this.fetchKPIData();
    }

    
    render() {
        // Group KPIs by Account instead of Channel
        // Output Structure: { "KARPON": [ { channel: "LinkedIn", ... }, { channel: "Website", ... }, ... ] }
        const accountsGrouped = {};

        this.state.kpis.forEach(item => {
            const accName = item.account || "Default Account";
            if (!accountsGrouped[accName]) {
                accountsGrouped[accName] = [];
            }
            accountsGrouped[accName].push(item);
        });

        // Ensure channels render in consistent order: LinkedIn -> Website -> SEO
        const targetChannelOrder = ["LinkedIn", "Website", "SEO"];

        return (
            <React.Fragment>
                <Box sx={{
                    width: "100%",
                   // height: "100%",
                   //eight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    boxSizing: "border-box",
                    p: { xs: 1, sm: 1.5 },
                    mb: 1.5,
                    borderRadius: 2,
                    background: "#ffffff20",
                    overflow: "hidden"
                }}>
                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        align="center"
                    >
                        KPI Dashboard
                    </Typography>
                    <Typography
                        variant="body2"
                        align="center"
                        color="text.secondary"
                    >
                        Performance Overview
                    </Typography>
                </Box>

                {/* Main Container */}
                <Box sx={{
                    flex: 1,
                    width: "100%",
                   // height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minHeight: 0,
                    gap: 1.5
                  //width: "100%", paddingX: 2, boxSizing: "border-box"
                 }}
                >
                    {Object.keys(accountsGrouped).map((accountName) => {
                        const accountItems = accountsGrouped[accountName];

                        // Sort array elements according to target channel order
                        accountItems.sort((a, b) =>
                            targetChannelOrder.indexOf(a.channel) - targetChannelOrder.indexOf(b.channel)
                        );

                        return (
                            <Box
                                key={accountName}
                                sx={{
                                    flex: 1, // Ensures Account 1 and Account 2 split vertical space 50/50
                                    display: "flex",
                                    flexDirection: "column",
                                    minHeight: 0,
                                    width: "100%",
                                   // height: "100%",
                                    
                                 // mb: 2
                                }}
                            >
                                    
                                              
                                {/* Account Title Row Header */}
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        fontWeight: "bold",
                                        mb: 1.5,
                                        color: "text.primary",
                                        borderBottom: "2px solid #e0e0e0",
                                        pb: 1.5,
                                        flexShrink: 0
                                    }}
                                >
                                    {accountName}
                                </Typography>

                                {/* 3-Card Row per Account */}
                                <Grid
                                    container
                                    spacing={2}
                                    alignItems="stretch"
                                    
                                    sx={{ flex: 1, minHeight: 0 }}
                                >
                                    {accountItems.map((item) => {
                                        //const rawGoal = item.goalImpressions ?? "N/A";
                                        const rawCurrent = item.currentMonthImpressions;
                                        const rawBest = item.totalImpressions || item.goalImpressions;
                                        //const rawPercent = goal > 0 ? (rawCurrent / goal) * 100 : 0;
                                        const isNull =

                                            rawCurrent == null ||
                                            rawCurrent == undefined ||
                                            rawBest == null ||
                                            rawBest == undefined ||
                                            rawBest == 0;

                                        const current = isNull ? 0 : rawCurrent
                                        const best = isNull ? 1 : rawBest
                                        // const displayPercent = rawPercent.toFixed(1);
                                       // const fraction = Math.min(Math.max(rawPercent / 100, 0), 1);

                                       // const themeColor =
                                          //  item.channel == "LinkedIn" ? "#06B6D4" :
                                          //  item.channel == "Website" ? "#3B82F6" : "#9333EA";

                                        
                                        const maxGauge = Math.max(current, best) * 1.3333;
                                        const needlePercent = isNull ? 0.5 : Math.min(current / maxGauge, 1);
                                        //const gaugePercent = current / maxGauge;
                                        const redEnd = (0.5 * best) / maxGauge;
                                        const yellowEnd = (0.5 * best) / maxGauge;
                                        const greenEnd = (maxGauge - best) / maxGauge;

                                        const rate = isNull ? null: (current / best) * 100 || 0;

                                        // const percent = goal === 0 ? 0 : (current / goal) * 100;

                                        

                                        const getTheme = () => {
                                            // Gray or Dimmed

                                            if (isNull) {
                                                return {
                                                    background: "#F8FAFC",   // Neutral Gray background
                                                    border: "#94A3B8",       // Muted Gray accent
                                                    text: "#64748B",         // Dimmed text
                                                    //accent: "#64748B",       // Slate badge
                                                    badgeBg: "#E2E8F0",
                                                    //gaugeColors: ["#CBD5E1", "#CBD5E1", "#CBD5E1"],
                                                };
                                            }

                                            // Red Theme
                                            if (rate < 50) {
                                                return {
                                                    background: "#FEF2F2",   // Soft Red
                                                    border: "#EF4444",
                                                    text: "#991B1B",
                                                    //accent: "#DC2626",
                                                    badgeBg: "#DC2626",
                                                    //gaugeColors: ["#EF4444", "#F59E0B", "#10B981"],

                                                };
                                            }

                                            // Yellow Theme
                                            if (rate < 100) {
                                                return {
                                                    background: "#FFFBEB",   // Soft Amber
                                                    border: "#F59E0B",
                                                    text: "#92400E",
                                                  //  accent: "#D97706",
                                                    badgeBg: "#D97706",
                                                  //  gaugeColors: ["#EF4444", "#F59E0B", "#10B981"],
                                                };
                                            }

                                            //const getTheme = (rate)

                                            // Green Theme
                                            return {
                                                background: "#ECFDF5",     // Soft Green
                                                border: "#10B981",
                                                text: "#065F46",
                                              //  accent: "#059669",
                                                badgeBg: "#059669",
                                              //  gaugeColors: ["#EF4444", "#F59E0B", "#10B981"],

                                                };
                                            };

                                            const theme = getTheme();


                                            return (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={6}
                                                    md={4} // Enforces 3 cards per row on desktop (12 / 4 = 3)
                                                    key={`${accountName}-${item.channel}`}
                                                //sx={{ height: "100%" }}
                                                >
                                                    <Card
                                                        sx={{
                                                            borderRadius: 4,
                                                            //    borderLeft: `8px solid ${theme.border}`,
                                                            //     backgroundColor: theme.background,
                                                            //   color: "white",
                                                            padding: 3,
                                                            height: "100%",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            backgroundColor: theme.background, // Dynamic card background
                                                            borderLeft: `8px solid ${theme.border}`, // Dynamic card left border
                                                            boxShadow: 3,
                                                            opacity: isNull ? 0.8 : 1.0, // Subtly dim whole card if null
                                                            transition: "0.2s",
                                                            "&:hover": {
                                                                transform: "translateY(-3px)",
                                                                boxShadow: 6
                                                            }
                                                        }}
                                                    >
                                                        {/* Header: Channel Name */}
                                                        <Box sx={{ textAlign: "center", mb: 1 }}>
                                                            <Typography
                                                                variant="h6"
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                    color: isNull ? "#64748B" : "#1E293B", 
                                                                    //   textTransform: "uppercase",
                                                                    letterSpacing: 0.5,
                                                                    fontSize: "1.5rem",
                                                                }}
                                                            >
                                                                {item.channel}
                                                            </Typography>
                                                            
                                                        </Box>

                                                        {/* Responsive Gauge Area */}
                                                        <Box
                                                            sx={{
                                                                //position: "relative",
                                                                width: "100%",
                                                                //maxWidth: 260,
                                                                my: 1,
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                //alignItems: "center",
                                                                //mb: 2
                                                            }}
                                                        >
                                                            {/* Achievement Percentage Badge */}
                                                            <Box sx={{
                                                                backgroundColor: theme.badgeBg,
                                                                color: isNull ? "#475569" : "#ffffff",
                                                                px: 2,
                                                                py: 1,
                                                                borderRadius: 3,
                                                                //boxShadow: `0 4px 10px ${theme.accent}40`
                                                            }}>

                                                                <Typography
                                                                    sx={{
                                                                        color: "#555",
                                                                        mt: 1.5
                                                                    }}
                                                                >
                                                                    Achievement vs Goal
                                                                </Typography>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        //      color: theme.text,
                                                                        fontWeight: "bold",
                                                                        fontSize: 22,
                                                                        color: isNull ? "#94A3B8" : theme.text,

                                                                    }}
                                                                >
                                                                    {isNull
                                                                        ? "No Data"
                                                                        : `${(rawCurrent ?? 0).toLocaleString()} / ${(item.goalImpressions ?? 0).toLocaleString()}`}

                                                                </Typography>

                                                            </Box>

                                                            {/* Right side */}
                                                            <Box
                                                                sx={{
                                                                    width: "100%",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    py: 1,
                                                                    px: 2,
                                                                    borderRadius: 3,
                                                                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                                                                    backdropFilter: "blur(4px)",
                                                                    filter: isNull ? "grayscale(100%) opacity(0.5)" : "none",

                                                                }}
                                                            >

                                                                <GaugeChart
                                                                    id={`gauge-${accountName}-${item.channel}`}
                                                                    nrOfLevels={3}
                                                                    arcsLength={isNull ? [0.33, 0.33, 0.34] : [redEnd, yellowEnd, greenEnd]}
                                                                    colors={ isNull? ["#CBD5E1", "#CBD5E1", "#CBD5E1"]: ["#EF4444", "#F59E0B", "#10B981"] }
                                                                    percent={needlePercent}
                                                                    needleColor={isNull ? "#94A3B8" : "#334155"}
                                                                    needleBaseColor={isNull ? "#94A3B8" : "#334155" }

                                                                    arcWidth={0.32}
                                                                    arcPadding={0}
                                                                    cornerRadius={6}
                                                                    hideText={true}
                                                                    animate={!isNull}
                                                                    style={{ width: "100%", height: "100%", maxWidth: 250 }}
                                                                    //hasNeedle={true}
                                                                                                                        
                                                                />

                                                            </Box>

                                                        </Box>


                                                        {/* Metrics Data Details */}

                                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, width: "100%", mt: 2, alignItems: "center", textAlign: "center" }}>
                                                            <Typography variant="caption" sx={{ opacity: 0.9, fontSize: "1rem" }}>
                                                                Best Week of All Time
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                                                                {item.totalImpressions != null
                                                                    ? item.totalImpressions.toLocaleString()
                                                                    : "N/A"}
                                                            </Typography>

                                                            <Typography variant="caption" sx={{ opacity: 0.9, fontSize: "1rem" }}>
                                                                Current Month Best
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                                                                {current.toLocaleString()} / {best.toLocaleString()}
                                                            </Typography>

                                                            <Typography variant="caption" sx={{ opacity: 0.9, fontSize: "1rem" }}>
                                                                Achievement Rate 
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                                                                {rate != null ? `${rate.toFixed(1)}% Achieved` : "N/A"}
                                                            </Typography>
                                                        </Box>
                                                    </Card>
                                                </Grid>
                                            );
                                        })}

                                </Grid>
                            </Box>
                        );
                    })}
                </Box>
            </React.Fragment>
        );
    }
}

